import { css } from '@emotion/react';

const GlobalStyle = css`
  /*  --------------------------------------------------------------------------------
  --- FONTS
  -------------------------------------------------------------------------------- */
  @font-face {
    font-family: Basel;
    src: url('/staticfront/fonts/BaselStandard-Medium.woff2');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: Basel;
    src: url('/staticfront/fonts/BaselStandard-Regular.woff2');
    font-weight: 400;
  }

  @font-face {
    font-family: Source;
    src: url('/staticfront/fonts/SourceSerif4-VariableFont_opsz,wght.ttf') format('truetype');
    font-weight: 600;
    font-variation-settings: 'wght' 600;
    font-style: normal;
    font-display: swap;
  }

  /*  --------------------------------------------------------------------------------
  --- RESET
  -------------------------------------------------------------------------------- */
  /*
  http://meyerweb.com/eric/tools/css/reset/
     v2.0 | 20110126
     License: none (public domain)
    */
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  body {
    line-height: 1;
    min-width: 320px;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  a {
    text-decoration: none;
  }

  /*  --------------------------------------------------------------------------------
  --- VAR
  -------------------------------------------------------------------------------- */
  :root {
    /* Font */
    --default-font-family: 'Helvetica', sans-serif;

    /* Size */
    --width-content-min: 600px;
    --width-content-max: 800px;
    --width-sidebar: 150px;
    --width-side-panel-regular: 400px;
    --width-side-panel-big: 800px;
    --height-header: 60px;

    /* Z-indexes */
    --z-index-content: 300;
    --z-index-sidebar: 400;
    --z-index-header: 450;
    --z-index-side-panel: 500;
    --z-index-toast: 700;
  }

  /*  --------------------------------------------------------------------------------
  --- GLOBAL
  -------------------------------------------------------------------------------- */
  html {
    height: 100%;
    font-weight: 400;
    font-size: 15px;
    font-feature-settings: 'lnum';
    box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
`;

export default GlobalStyle;
